"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _get2 = _interopRequireDefault(require("lodash-es/get"));

var _uniqBy2 = _interopRequireDefault(require("lodash-es/uniqBy"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _icon = _interopRequireDefault(require("../../atoms/icon"));

var _popover = _interopRequireDefault(require("../../atoms/_popover"));

var _selectableList = _interopRequireDefault(require("../selectable-list"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject7() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    ", ":last-child {\n        margin-right: auto;\n        margin-left: 8px;\n    }\n    cursor: pointer;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  text-transform: capitalize;\n  color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  text-align: left;\n  text-transform: uppercase;\n  font-weight: ", ";\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    &:hover {\n        background: ", ";\n      }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-height: 360px;\n  overflow-y: auto;\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  text-align: center;\n  text-transform: uppercase;\n  padding: ", " ", ";\n  border: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  &:focus {\n    outline: none;\n    pointer-events: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var priorityType = 'priority';
var modeType = 'mode';

var getViews = function getViews(props) {
  return (0, _versions.getColor)(props, 'badge');
};

var getDefaultData = function getDefaultData(props) {
  var color = getViews(props)["default"];
  return {
    color: color.text,
    menuTextColor: color.menuText,
    iconColor: color.icon,
    menuIcon: 'active-circle',
    borderColor: color.border,
    backgroundColor: color.background,
    hoverBackground: color.hoverBackground
  };
};

var getPriorityBadge = function getPriorityBadge(props) {
  var views = getViews(props);
  return {
    high: {
      color: views.high.text,
      menuTextColor: views.high.menuText,
      iconColor: views.high.icon,
      borderColor: views.high.border,
      backgroundColor: views.high.background,
      hoverBackground: views.high.hoverBackground
    },
    medium: {
      color: views.medium.text,
      menuTextColor: views.medium.menuText,
      iconColor: views.medium.icon,
      borderColor: views.medium.border,
      backgroundColor: views.medium.background,
      hoverBackground: views.medium.hoverBackground
    },
    low: {
      color: views.low.text,
      menuTextColor: views.low.menuText,
      iconColor: views.low.icon,
      borderColor: views.low.border,
      backgroundColor: views.low.background,
      hoverBackground: views.low.hoverBackground
    },
    neutral: {
      color: views.neutral.text,
      menuTextColor: views.neutral.menuText,
      iconColor: views.neutral.icon,
      borderColor: views.neutral.border,
      backgroundColor: views.neutral.background,
      hoverBackground: views.neutral.hoverBackground
    }
  };
};

var getModeBadge = function getModeBadge(props) {
  var views = getViews(props);
  return {
    active: {
      color: views.active.text,
      menuTextColor: views.active.menuText,
      iconColor: views.active.icon,
      menuIcon: 'active-circle',
      borderColor: views.active.border,
      backgroundColor: views.active.background
    },
    archived: {
      color: views.archived.text,
      menuTextColor: views.archived.menuText,
      iconColor: views.archived.icon,
      menuIcon: 'archived-circle',
      borderColor: views.archived.border,
      backgroundColor: views.archived.background
    },
    pending: {
      color: views.pending.text,
      menuTextColor: views.pending.menuText,
      iconColor: views.pending.icon,
      menuIcon: 'pending-circle',
      borderColor: views.pending.border,
      backgroundColor: views.pending.background
    }
  };
}; // const defaultData = {
//   color: colors.badge.default.text,
//   menuTextColor: colors.badge.default.menuText,
//   iconColor: colors.badge.default.icon,
//   menuIcon: 'active-circle',
//   borderColor: colors.badge.default.border,
//   backgroundColor: colors.badge.default.background,
//   hoverBackground: colors.badge.default.hoverBackground
// }
// const priorityBadge = {
//   high: {
//     color: colors.badge.high.text,
//     menuTextColor: colors.badge.high.menuText,
//     iconColor: colors.badge.high.icon,
//     borderColor: colors.badge.high.border,
//     backgroundColor: colors.badge.high.background,
//     hoverBackground: colors.badge.high.hoverBackground
//   },
//   medium: {
//     color: colors.badge.medium.text,
//     menuTextColor: colors.badge.medium.menuText,
//     iconColor: colors.badge.medium.icon,
//     borderColor: colors.badge.medium.border,
//     backgroundColor: colors.badge.medium.background,
//     hoverBackground: colors.badge.medium.hoverBackground
//   },
//   low: {
//     color: colors.badge.low.text,
//     menuTextColor: colors.badge.low.menuText,
//     iconColor: colors.badge.low.icon,
//     borderColor: colors.badge.low.border,
//     backgroundColor: colors.badge.low.background,
//     hoverBackground: colors.badge.low.hoverBackground
//   },
//   neutral: {
//     color: colors.badge.neutral.text,
//     menuTextColor: colors.badge.neutral.menuText,
//     iconColor: colors.badge.neutral.icon,
//     borderColor: colors.badge.neutral.border,
//     backgroundColor: colors.badge.neutral.background,
//     hoverBackground: colors.badge.neutral.hoverBackground
//   }
// }
// const modeBadge = {
//   active: {
//     color: colors.badge.active.text,
//     menuTextColor: colors.badge.active.menuText,
//     iconColor: colors.badge.active.icon,
//     menuIcon: 'active-circle',
//     borderColor: colors.badge.active.border,
//     backgroundColor: colors.badge.active.background
//   },
//   archived: {
//     color: colors.badge.archived.text,
//     menuTextColor: colors.badge.archived.menuText,
//     iconColor: colors.badge.archived.icon,
//     menuIcon: 'archived-circle',
//     borderColor: colors.badge.archived.border,
//     backgroundColor: colors.badge.archived.background
//   },
//   pending: {
//     color: colors.badge.pending.text,
//     menuTextColor: colors.badge.pending.menuText,
//     iconColor: colors.badge.pending.icon,
//     menuIcon: 'pending-circle',
//     borderColor: colors.badge.pending.border,
//     backgroundColor: colors.badge.pending.background
//   }
// }


var getTagStyles = function getTagStyles(props) {
  var views = getViews(props);
  return {
    color: views.tag.text,
    backgroundColor: views.tag.background,
    borderColor: views.tag.border
  };
}; // const tagStyle = {
//   color: colors.badge.tag.text,
//   backgroundColor: colors.badge.tag.background,
//   borderColor: colors.badge.tag.border
// }


var convertStyle = function convertStyle(props) {
  var color = props.colors.text || getTagStyles(props).color;
  var borderColor = props.colors.border || getTagStyles(props).borderColor;
  var backgroundColor = props.colors.background || getTagStyles(props).backgroundColor;
  return {
    color: color,
    borderColor: borderColor,
    backgroundColor: backgroundColor
  };
};

var getStyles = function getStyles(props) {
  var priorityBadge = getPriorityBadge(props);
  var defaultData = getDefaultData(props);
  var modeBadge = getModeBadge(props);

  if (props.kind === 'status') {
    return (0, _get2["default"])(priorityBadge, props.priority, defaultData);
  }

  if (props.kind === 'dropdown') {
    if (props.type === modeType) {
      return (0, _get2["default"])(modeBadge, props.mode, defaultData);
    }

    return (0, _get2["default"])(priorityBadge, props.priority, defaultData);
  }

  if (props.kind === 'tag') {
    if (props.colors) {
      return convertStyle(props);
    }

    return getTagStyles(props);
  }

  return defaultData;
}; // component of badge - kind tag


var Tag = function Tag(props) {
  var children = props.children;
  var content = [];

  if (children) {
    content.push(_react["default"].createElement(Badge.Text, _extends({
      key: "child"
    }, props), children));
  }

  return _react["default"].createElement(Badge.Element, props, content);
}; // component of badge - kind status


var StatusBadge = function StatusBadge(props) {
  var important = props.important,
      children = props.children;
  var content = [];

  if (important) {
    content.push(_react["default"].createElement(_icon["default"], {
      key: "right-icon",
      size: 16,
      name: "alert",
      color: getStyles(props).iconColor
    }));
  }

  if (children) {
    content.push(_react["default"].createElement(Badge.Text, _extends({
      key: "child"
    }, props), children));
  }

  return _react["default"].createElement(StatusBadge.Element, props, content);
}; // component of badge - kind dropdown


var checkStatus = function checkStatus(item, type, status) {
  if (type === modeType) {
    return item.mode === status;
  }

  return item.priority === status;
};

var DropdownBadge =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownBadge, _React$Component);

  function DropdownBadge(_props) {
    var _this;

    _classCallCheck(this, DropdownBadge);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownBadge).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      var _this$getSelectedMenu = _this.getSelectedMenuItem(nextProps),
          initialPriority = _this$getSelectedMenu.initialPriority,
          initialMode = _this$getSelectedMenu.initialMode;

      _this.setState({
        status: initialPriority || initialMode || ''
      }, function () {
        _this.Content.blur();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedMenuItem", function (props) {
      var menuItem = _react["default"].Children.toArray(props.children).map(function (childMenu) {
        return childMenu.props || {};
      });

      var type = props.type;
      var selectedItem = menuItem.find(function (item) {
        return item.selected;
      }) || menuItem[0];
      var initialPriority = type === priorityType ? (0, _get2["default"])(selectedItem, 'priority', props.priority) : undefined;
      var initialMode = type === modeType ? (0, _get2["default"])(selectedItem, 'mode', props.mode) : undefined;
      return {
        initialPriority: initialPriority,
        initialMode: initialMode
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onSelected", function (itemselected, menuItems, type, status) {
      var selectedItem = menuItems.find(function (item) {
        return checkStatus(item, type, itemselected);
      });
      if (!selectedItem) return;
      delete selectedItem.kind;
      delete selectedItem.type;
      delete selectedItem.selected;
      type === priorityType ? delete selectedItem.mode : delete selectedItem.priority;

      _this.setState({
        status: itemselected
      }, function () {
        _this.Content.blur();

        _this.props.onSelected(selectedItem);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function (menuItems, type, status) {
      var lists = [];
      menuItems.forEach(function (item, index) {
        var value;

        if (item.label) {
          value = type === priorityType ? item.priority : item.mode;
          lists.push(_react["default"].createElement(_selectableList["default"].Item, {
            key: item.label + index,
            value: value
          }, type === modeType && _react["default"].createElement(_icon["default"], {
            size: 16,
            name: getStyles(_objectSpread({}, item, {
              version: _this.props.version
            })).menuIcon
          }), _react["default"].createElement(DropdownBadge.MenuText, _extends({}, item, _this.props), item.label)));
        }
      });
      return _react["default"].createElement(Content, {
        tabIndex: '0',
        innerRef: function innerRef(e) {
          return _this.Content = e;
        }
      }, _react["default"].createElement(_selectableList["default"], {
        lean: true,
        selected: status,
        onSelection: function onSelection(v) {
          return _this.onSelected(v, menuItems, type, status);
        }
      }, lists));
    });

    var _this$getSelectedMenu2 = _this.getSelectedMenuItem(_props),
        _initialPriority = _this$getSelectedMenu2.initialPriority,
        _initialMode = _this$getSelectedMenu2.initialMode;

    _this.state = {
      status: _initialPriority || _initialMode || ''
    };
    return _this;
  }

  _createClass(DropdownBadge, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          fullWidth = _this$props.fullWidth,
          position = _this$props.position,
          disabled = _this$props.disabled,
          adjustVerticalAlign = _this$props.adjustVerticalAlign,
          priority = _this$props.priority,
          mode = _this$props.mode,
          type = _this$props.type,
          kind = _this$props.kind;
      var status = this.state.status; // child components

      var menuItem = _react["default"].Children.toArray(children).map(function (childMenu) {
        var item = _objectSpread({}, childMenu.props, {
          kind: kind,
          type: type
        });

        type === priorityType ? !item.priority && (item.priority = priority) // add default priority
        : !item.mode && (item.mode = mode); // add default mode

        return item;
      });

      var currentType = type === priorityType ? priorityType : modeType;
      menuItem = (0, _uniqBy2["default"])(menuItem, currentType); // badge

      var content = []; // selectedItem means item with prop 'selected' or first child

      var selectedItem = menuItem.find(function (item) {
        return checkStatus(item, type, status);
      });
      selectedItem ? content.push(_react["default"].createElement(Badge.Text, _extends({
        key: "child"
      }, selectedItem, {
        version: this.props.version,
        lol: "lol"
      }), selectedItem.label), _react["default"].createElement(_icon["default"], {
        key: "chevron-down",
        size: 12,
        name: "chevron-down",
        color: getStyles(_objectSpread({}, selectedItem, {
          version: this.props.version
        })).iconColor
      })) : content.push(_react["default"].createElement(Badge.Text, _extends({
        key: "child"
      }, this.props, {
        lol2: "lol2"
      }), "NoChild"));
      var dropdownMenuContent = this.renderContent(menuItem, type, status);
      return _react["default"].createElement(_popover["default"], {
        content: dropdownMenuContent,
        fullWidth: fullWidth,
        position: position,
        adjustVerticalAlign: adjustVerticalAlign,
        contentDisabled: disabled
      }, _react["default"].createElement(DropdownBadge.Element, _extends({}, this.props, {
        priority: status,
        mode: status
      }), content));
    }
  }]);

  return DropdownBadge;
}(_react["default"].Component); // main Badge classs


var Badge =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(Badge, _React$Component2);

  function Badge(props) {
    var _this2;

    _classCallCheck(this, Badge);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Badge).call(this, props));
    _this2.state = {};
    return _this2;
  } // getBadge = () => {
  //   const { kind, children } = this.props
  //   let badge
  //   switch (kind) {
  //     case 'tag':
  //       badge = (
  //         <Tag {...this.props}>
  //           {' '}
  //           {children}{' '}
  //         </Tag>
  //       )
  //       break
  //     case 'status':
  //       badge = (
  //         <StatusBadge {...this.props}>
  //           {' '}
  //           {children}{' '}
  //         </StatusBadge>
  //       )
  //       break
  //     case 'dropdown':
  //       badge = <DropdownBadge {...this.props} />
  //       break
  //     default:
  //       badge = (
  //         <Tag {...this.props}>
  //           {' '}
  //           {children}{' '}
  //         </Tag>
  //       )
  //       break
  //   }
  //   return badge
  // }


  _createClass(Badge, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          kind = _this$props2.kind,
          children = _this$props2.children;
      var badge;

      switch (kind) {
        case 'tag':
          badge = _react["default"].createElement(Tag, this.props, " ", children, " ");
          break;

        case 'status':
          badge = _react["default"].createElement(StatusBadge, this.props, " ", children, " ");
          break;

        case 'dropdown':
          badge = _react["default"].createElement(DropdownBadge, this.props);
          break;

        default:
          badge = _react["default"].createElement(Tag, this.props, " ", children, " ");
          break;
      }

      return badge;
    }
  }]);

  return Badge;
}(_react["default"].Component); // styled component of badge


Badge.Element = _styledComponents["default"].button(_templateObject(), _tokens.spacing.xxsmall, _tokens.spacing.xsmall, function (props) {
  if (!props.bordered) return 'none';
  return "1px solid ".concat(getStyles(props).borderColor);
}, _tokens.spacing.small, function (props) {
  return getStyles(props).backgroundColor;
});

var Content = _styledComponents["default"].div(_templateObject2());

StatusBadge.Element = Badge.Element.extend(_templateObject3(), function (props) {
  return getStyles(props).hoverBackground;
});
Badge.Text = _styledComponents["default"].text(_templateObject4(), _tokens.fonts.weight.semiBold, function (props) {
  return getStyles(props).color;
});
DropdownBadge.MenuText = Badge.Text.extend(_templateObject5(), function (props) {
  return getStyles(props).menuTextColor;
});
DropdownBadge.Element = Badge.Element.extend(_templateObject6(), _icon["default"].Element);

var MenuContent = _styledComponents["default"].div(_templateObject7());

Badge.MenuItem = function (props) {
  return _react["default"].createElement(MenuContent, null, props.children);
};

DropdownBadge.propTypes = {
  label: _propTypes["default"].string.isRequired
};
Badge.MenuItem.propTypes = {
  priority: _propTypes["default"].oneOf(Object.keys(['high', 'medium', 'low', 'neutral'])),
  mode: _propTypes["default"].oneOf(Object.keys(['active', 'archived', 'pending']))
};
Badge.propTypes = {
  kind: _propTypes["default"].oneOf(['status', 'dropdown', 'tag']).isRequired,
  important: _propTypes["default"].bool,
  border: _propTypes["default"].bool,
  onSelected: _propTypes["default"].func
};
Badge.MenuItem.defaultProps = {
  // default priority
  priority: 'neutral',
  // default mode
  mode: 'active'
};
Badge.defaultProps = {
  // for status badge hide alert Icon
  important: false,
  bordered: true,
  // default kind
  kind: 'tag',
  // default type priority
  type: 'priority',
  // default function
  onSelected: _noop2["default"]
};
Badge.displayName = 'Badge';

var _default = (0, _context.withVersion)(Badge);

exports["default"] = _default;